import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        border: 'none !important',

        '.MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            minHeight: '40px !important',
            paddingBottom: '0 !important',
            paddingTop: '0 !important',
            paddingRight: '0 !important',
        },
    },
    menuList: {
        '.MuiMenu-list': {
            padding: 0,
        },
    },
    menuItem: {
        padding: '19px 25px',
        background: `${theme.palette.background.paper} !important`,
        color: isHosTheme
            ? `${theme.palette.common.white} !important`
            : `${theme.palette.common.black} !important`,
    },
    nameText: css({
        cursor: 'pointer',
        color: isHosTheme
            ? `${theme.palette.common.white} !important`
            : `${theme.palette.common.black} !important`,
    }),
};
